import { GatsbyBrowser } from "gatsby";
import { NavigationMenuWrapper } from "./src/components/navigationMenu/NavigationMenuWrapper";

export const wrapPageElement: GatsbyBrowser["wrapPageElement"] = ({
  element,
  props,
}) => <NavigationMenuWrapper {...props}>{element}</NavigationMenuWrapper>;
